import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "@/lib/analytics";

/**
 * Sends a `page_view` event to GA4 on every route change.
 * Must be mounted INSIDE <BrowserRouter>.
 */
export const RouteTracker = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    trackPageView(pathname + search);
  }, [pathname, search]);

  return null;
};
